import i18n from "../i18n";

type DateInput = string | Date;

const localeMap: Record<string, string> = {
  en: "en-US",
  fr: "fr-FR",
};

function getLocale(): string {
  const lang = i18n.language?.startsWith("fr") ? "fr" : "en";
  return localeMap[lang];
}

/** Format a date using the current i18n locale. */
export function formatDate(
  date: DateInput,
  options?: Intl.DateTimeFormatOptions,
): string {
  const d = typeof date === "string" ? new Date(date) : date;
  return d.toLocaleDateString(getLocale(), options);
}

/** Short date: "12/25/2024" (en) or "25/12/2024" (fr) */
export function formatDateShort(date: DateInput): string {
  return formatDate(date);
}

/** Long date: "December 25, 2024" (en) or "25 décembre 2024" (fr) */
export function formatDateLong(date: DateInput): string {
  return formatDate(date, { year: "numeric", month: "long", day: "numeric" });
}

/** Medium date: "Dec 25, 2024" (en) or "25 déc. 2024" (fr) */
export function formatDateMedium(date: DateInput): string {
  return formatDate(date, { year: "numeric", month: "short", day: "numeric" });
}

/** Chart tick: "Dec 24" (en) or "déc. 24" (fr) */
export function formatDateChart(date: DateInput): string {
  return formatDate(date, { month: "short", year: "2-digit" });
}

/** Chart tick short: "12/25" (en) or "25/12" (fr) */
export function formatDateChartShort(date: DateInput): string {
  return formatDate(date, { day: "2-digit", month: "2-digit" });
}
